// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentsFragmentDoc } from './component.generated';
import { ComponentGlobalComponentFragmentDoc } from './component/ComponentGlobalComponent.fragment.generated';
export const ComponentFragmentDoc = gql`
    fragment component on Component {
  __typename
  ...components
  ...componentGlobalComponent
}
    ${ComponentsFragmentDoc}
${ComponentGlobalComponentFragmentDoc}`;